import React from "react";
import { IconButton } from "@src/components";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
import { ConvertPhoneNumber } from "@src/utils/units";
import { KakaoFriendDto } from "./service/types";

const cellStyle: React.CSSProperties = {
    width: "100%",
    minWidth: "80px",
    textAlign: "center",
};

export const getColumns = (navigate: any) => [
    {
        Header: "번호",
        accessor: "no",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "50px" }}>{value ?? INVALID_VALUE}</div>
        ),
    },
    {
        Header: "유저 이름",
        accessor: "info",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "120px" }}>
                {value?.uname ? value.uname : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "전화 번호",
        accessor: "phone",
        Cell: ({ row }: any) => {
            const friend: KakaoFriendDto = row?.original;
            return (
                <div style={{ ...cellStyle, minWidth: "160px" }}>
                    {friend?.info?.phone
                        ? ConvertPhoneNumber(friend.info.phone)
                        : INVALID_VALUE}
                </div>
            );
        },
    },
    {
        Header: "이메일",
        accessor: "id",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "200px" }}>
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "등록일",
        accessor: "createdAt",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "100px" }}>
                {value ? value.slice(0, 10) : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "더보기",
        accessor: "viewMore",
        Cell: ({ row }: any) => {
            const friend: KakaoFriendDto = row?.original;
            return (
                <div
                    style={{
                        ...cellStyle,
                        minWidth: "70px",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        type={"arrow"}
                        color={"black"}
                        handleClick={() => {
                            navigate(`/users/detail/${friend.userNo}`);
                        }}
                    />
                </div>
            );
        },
    },
];
